import React, { useState } from 'react';
import './portfolio.css';
import { projectData } from './Data';

const Portfolio = () => {
  const [filter, setFilter] = useState('all');
  const [showAll, setShowAll] = useState(false);

  const filters = [
    { key: 'all', label: 'All Projects' },
    { key: 'fullstack', label: 'Full Stack' },
    { key: 'ml', label: 'ML / Data Science' },
  ];

  const filteredProjects = filter === 'all' 
    ? projectData 
    : projectData.filter(p => p.category === filter);

  const displayedProjects = showAll ? filteredProjects : filteredProjects.slice(0, 6);

  return (
    <div id="projects">
      <section className="portfolio section">
        <div className="container">
          <div className="section__header reveal">
            <span className="section__label">Projects</span>
            <h2 className="section__title">Featured Work</h2>
            <p className="section__subtitle">A showcase of projects I've built and contributed to</p>
          </div>

          <div className="portfolio__filters reveal">
            {filters.map((f) => (
              <button
                key={f.key}
                className={`portfolio__filter ${filter === f.key ? 'portfolio__filter--active' : ''}`}
                onClick={() => { setFilter(f.key); setShowAll(false); }}
                id={`filter-${f.key}`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="portfolio__grid reveal">
            {displayedProjects.map((project) => (
              <article className="portfolio__card" key={project.id}>
                <div className="portfolio__card-header">
                  <div className="portfolio__card-icon">
                    <i className="bx bx-folder-open"></i>
                  </div>
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio__card-link"
                    aria-label={`View ${project.title} on GitHub`}
                  >
                    <i className="bx bxl-github"></i>
                  </a>
                </div>

                <h3 className="portfolio__card-title">
                  <a href={project.github} target="_blank" rel="noopener noreferrer">
                    {project.title}
                  </a>
                </h3>

                <p className="portfolio__card-description">{project.description}</p>

                <div className="portfolio__card-tags">
                  {project.tags.map((tag, i) => (
                    <span key={i} className="portfolio__tag">{tag}</span>
                  ))}
                </div>
              </article>
            ))}
          </div>

          {filteredProjects.length > 6 && (
            <div className="portfolio__more reveal">
              <button 
                className="btn btn--outline" 
                onClick={() => setShowAll(!showAll)}
                id="show-more-projects-btn"
              >
                {showAll ? 'Show Less' : `Show All (${filteredProjects.length})`}
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;